import { isSystem } from '@umu/ukit-lang';

export const computeShowPrice = (num: number) => {
    const value = Number(num).toFixed(2);
    const valArr = value.split('.');
    let inte = valArr[0];
    const fen = valArr[1];
    inte = inte.replace(/\d+/, function (s) {
        return s.replace(/(\d)(?=(\d{3})+$)/g, '$1,');
    });
    return fen === '00' ? inte : `${inte}.${fen}`;
};

/**
 * @description 从字符串中获取所有数字，并返回非“0”开始的正整数字符串
 * @param numStr
 * @returns {string}
 */
export const pureNumber = (numStr: string): string => {
    if (/^[0]{2,}$/g.test(numStr)) {
        return '0';
    }
    return numStr.replace(/[^0-9]/g, '').replace(/^0*/g, '');
};

/**
 * @desc 数字转换为千分符
 * @param num 传入的数字
 * @return 加了千位符的字符串
 */
export function numToThousands(num: number = 0) {
    const thousandPattern = /(-?\d+)(\d{3})/;
    let formatData = num.toString();
    while (thousandPattern.test(formatData)) {
        formatData = formatData.replace(thousandPattern, '$1,$2');
    }
    return formatData;
}

// 功能: 是否为 co 站点
export function isCoSite() {
    return isSystem('jp');
}

export function isCom() {
    return isSystem('en');
}

export function isIo() {
    return isSystem('em');
}
